import C from "@/modules/dashboard/Dashboard.module.css";

import { NoSuspense } from "@/components/dev/DoNotSuspendHere.tsx";
import { IsoCerts } from "@/components/IsoCerts.tsx";
import { useConfig } from "@/config.ts";
import { eBillingAccountQueryAtom } from "@/modules/billing/billingAccountQuery.ts";
import { ReferralProgram } from "@/modules/billing/referral/ReferralProgram.tsx";
import { BillingAccounts } from "@/modules/dashboard/BillingAccounts.tsx";
import { DashboardNotices } from "@/modules/dashboard/DashboardNotices.tsx";
import { RecentlyModified } from "@/modules/dashboard/RecentlyModified.tsx";
import { StartSomethingNew } from "@/modules/dashboard/StartSomethingNew.tsx";
import { UserAccess } from "@/modules/dashboard/UserAccess.tsx";
import { welcomeSeenAtom } from "@/modules/dashboard/welcome.store.ts";
import { WelcomeBlock } from "@/modules/dashboard/WelcomeBlock.tsx";
import { WelcomeModal } from "@/modules/dashboard/WelcomeModal.tsx";
import { SupportLink } from "@/modules/support/SupportLink.tsx";
import { useThemeProps } from "@/modules/theme/useTheme.ts";
import { userIsAdminAtom } from "@/modules/user/userApi.ts";
import { useSuspenseQueryAtom } from "@/utils/query/useSuspenseQueryAtom.ts";
import { useTitle } from "@/utils/react/useTitle.ts";
import { Trans, useLingui } from "@lingui/react/macro";
import { useStore } from "jotai";
import { Suspense } from "react";

function SupportBlock() {
    const { isoCertificates, isoCertificatesHiddenDesktop } = useThemeProps();

    const support = (
        <p className="color-muted text-center font-size-small">
            <Trans>
                If you have any questions, found a bug or have a feature request feel free to contact us through{" "}
                <SupportLink>support</SupportLink>.
            </Trans>
        </p>
    );

    return isoCertificates?.length && !isoCertificatesHiddenDesktop ? (
        <div className={C.Support}>
            <IsoCerts />

            {support}
        </div>
    ) : (
        support
    );
}

export default function Dashboard() {
    const { t } = useLingui();
    useTitle(t`Dashboard`);

    const { referralCodeEnabled } = useConfig();

    const children = (
        <div className={C.DashboardHolder}>
            <Suspense>
                <WelcomeModalLoader />
            </Suspense>

            <DashboardNotices />

            <WelcomeBlock />

            <StartSomethingNew />

            <div className={C.Recent}>
                <RecentlyModified />
                <UserAccess />
                <BillingAccounts />
            </div>

            {referralCodeEnabled && <ReferralProgram variant="dashboard" />}

            <SupportBlock />
        </div>
    );
    return <NoSuspense>{children}</NoSuspense>;
}

// TODO/J: Should probably be loaded in root component, not dashboard?
function WelcomeModalLoader() {
    const accounts = useSuspenseQueryAtom(eBillingAccountQueryAtom);
    const isAdmin = useSuspenseQueryAtom(userIsAdminAtom);
    const store = useStore();

    if (isAdmin || accounts.size || store.get(welcomeSeenAtom)) {
        return null;
    }

    return <WelcomeModal isVisible={true} />;
}
